import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

const PlusIcon = (props) => (
  <Svg
    width={15}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12.816 5.683H8.39V1.275c0-1.7-2.647-1.7-2.647 0v4.408H1.317c-1.706 0-1.706 2.636 0 2.636h4.426v4.408c0 1.7 2.647 1.7 2.647 0V8.319h4.425c1.707 0 1.707-2.636 0-2.636Z"
        fill="#fff"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.037)" d="M0 0h14.057v14H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default PlusIcon;
